import React, { FC, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { withProcedureWraper } from "../..";
import { Routes } from "../../../../AppRoutes";
import { Box } from "../../../../components/box";
import { Icon } from "../../../../components/icon";
import { getDDMMYYYFormat, isDateInRange } from "../../../../helper/dateTimeHelper";
import { approverType } from "../code-process/codeRequestType";
import CreateRequestButton from "../../components/CreateRequestButton";
import { ExportFileExcel } from "../components";

import moment, { Moment } from "moment";
import { compareRequestStatus, getRequestStatusHasAssigneeOptions } from "../../utils";
import { requestStatusTypes } from "../types";
import { getStatusBaseOnApprover, getStepBaseOnApprover } from "../delete-user-account/utils";
import { useUser } from "../../../../hook";
import { useEprCodeColumns } from "./hooks/use-epr-code-columns";
import { useEPRCodeRequests } from "./hooks";
import { Table, UserManual } from "../../../../components";
import { AiOutlineFilter } from "react-icons/ai";

export type MyReqSearchBoxType = {
  id: number;
  createdDateTime: Date;
  displayName: string;
};

export const procedureProcessEpr: FC = withProcedureWraper(() => {
  const history = useHistory();
  const { email } = useUser();
  const { columns } = useEprCodeColumns();
  const { mappedEPRCodeMyRequests, mappedEPRCodeRequests2 = [], isLoading, guideLink } = useEPRCodeRequests();

  const [filters, setFilters] = useState<any>({
    createdDateTime: null,
    eRequestStatus: null,
  });

  const filteredDataSource = useMemo(() => {
    let dataSource = [...mappedEPRCodeRequests2];
    if (filters.eRequestStatus) {
      dataSource = dataSource.filter((e: any) => compareRequestStatus(e.eRequestStatus, filters?.eRequestStatus!));
    }
    if (filters.createdDateTime) {
      const [startDate, endDate]: [Moment, Moment] = filters.createdDateTime;
      dataSource = dataSource.filter((e: any) => {
        const createDate = moment(e.createdDateTime);
        return isDateInRange(createDate, startDate.startOf("day"), endDate.endOf("day"));
      });
    }

    return dataSource;
  }, [filters, mappedEPRCodeRequests2]);

  const requestStatusOptions = getRequestStatusHasAssigneeOptions("Đã cấp mới");

  const flattedData = mappedEPRCodeRequests2.map((record: any) => {
    const status = getStatusBaseOnApprover(record, email);
    const step = getStepBaseOnApprover(record, email);

    const requestStatus =
      status === requestStatusTypes.submitted && step === approverType.assignee
        ? requestStatusTypes.submittedAssignee
        : record.eRequestStatus;
    return {
      id: record.id,
      createdDateTime: getDDMMYYYFormat(record.createdDateTime),
      eRequestStatus: record.eRequestStatus,
      eRequestPersonName: record.createdByName,
      eRequestType: record.eRequestType === "provide" ? "Cấp mới" : "Thay đổi",
      ePhoneNumber: record.ePhoneNumber,
      eDepartment: record.eDepartment,
      eUnit: record.eUnit,
      eDescription: record.eDescription,
      eRequestStatusText: requestStatusOptions.find((e) => e.value === requestStatus)?.label,
    };
  });

  return (
    <div className="ITCodeGrantedPage">
      <div className="pd15">
        <UserManual title="CẤP/THAY ĐỔI/XOÁ CODE AMADEUS" icon={<Icon.DocumentWrite />} guideLink={guideLink} />
        <Box
          title="Yêu cầu của tôi"
          titleRight={
            <CreateRequestButton onClick={() => history.push(Routes.createProcessEprPage.path.replace(":id", "0"))} />
          }
        >
          <Table
            loading={isLoading}
            rowKey="id"
            columns={columns}
            dataSource={mappedEPRCodeMyRequests}
            scroll={{ x: 1100 }}
            onRow={(record) => ({
              onClick: () => history.push(Routes.processEprDetailPage.path.replace(":id", record.id)),
              style: { cursor: "pointer" },
            })}
          />
        </Box>

        <Box
          title="Các yêu cầu cần duyệt"
          titleRight={
            <ExportFileExcel
              exportContent={{
                fileName: "Danh sach yeu cau can duyet cap/thay doi code Amadeus",
                content: [
                  { header: "Mã yêu cầu", dataIndex: "id" },
                  { header: "Yêu cầu", dataIndex: "eRequestType" },
                  { header: "Người yêu cầu", dataIndex: "eRequestPersonName" },
                  { header: "SĐT Người yêu cầu", dataIndex: "ePhoneNumber" },
                  { header: "Cơ quan/Đơn vị", dataIndex: "eDepartment" },
                  { header: "Đơn vị", dataIndex: "eUnit" },
                  { header: "Mô tả", dataIndex: "eDescription" },
                  { header: "Trạng thái", dataIndex: "eRequestStatusText" },
                ],
              }}
              data={flattedData}
              initialValues={filters}
              requestStatusOptions={requestStatusOptions}
              onChange={(_, allValues: any) => setFilters(allValues)}
            >
              <div>
                <CreateRequestButton label="Bộ lọc" prefixIcon={<AiOutlineFilter />} />
              </div>
            </ExportFileExcel>
          }
        >
          <Table
            loading={isLoading}
            rowKey="id"
            columns={columns}
            dataSource={filteredDataSource}
            scroll={{ x: 1100 }}
            onRow={(record) => ({
              onClick: () => history.push(Routes.processEprDetailPage.path.replace(":id", record.id)),
              style: { cursor: "pointer" },
            })}
          />
        </Box>
      </div>
    </div>
  );
});
